angular.module('app').factory('casinoJobService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoJob/");

        return {
            getNotReleasedSkins: function (requestData) {
                return restAngular.
                one("getNotReleasedSkins").
                customGET(param(requestData))
            },
            getSkinsList: function (requestData) {
                if (!requestData) {
                    requestData = {status: 'published'};
                }
                return restAngular.
                one("getSkinsList").
                customGET(param(requestData))
            },
            getJobReleaseList: function (requestData) {
                return restAngular
                    .one("get")
                    .customGET(param(requestData))
            },
            getSkinJobPossibleCancellationSkins: function (requestData) {
                return restAngular
                    .one("getPossibleCancellationSkins")
                    .customGET(param(requestData))
            },
            getSkinJobReleaseList: function (requestData) {
                return restAngular
                    .one("getSkinsJobList")
                    .customGET(param(requestData))
            },
            startRelease: function (requestData) {
                return restAngular
                    .one("startRelease")
                    .post('', requestData)
            },
            cancel: function (requestData) {
                return restAngular
                    .one("cancel")
                    .post('', requestData)
            },
        }
    }
]);
